module.exports = __webpack_public_path__ + "static/media/joinUsImage.90648636.jpg";